import { render, staticRenderFns } from "./CrudEspecializacao.vue?vue&type=template&id=2fc3fc6e"
import script from "./CrudEspecializacao.vue?vue&type=script&lang=js"
export * from "./CrudEspecializacao.vue?vue&type=script&lang=js"
import style0 from "./CrudEspecializacao.vue?vue&type=style&index=0&id=2fc3fc6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports